export const esquemaEmpleado = [
  { name: 'nombres', type: 'String', required: true, maxlength: 40 },
  { name: 'primerApellido', type: 'String', required: true, maxlength: 30 },
  {
    name: 'segundoApellido',
    type: 'String',
    required: false,
    maxlength: 30,
  },
  { name: 'TipoDocumento', type: 'Enum', required: true },
  {
    name: 'NumeroDocumento',
    type: 'Integer',
    required: true,
    min: 0,
    maxlength: 15,
  },
  { name: 'Cargo', type: 'String', required: true, maxlength: 70 },
  { name: 'FechaIngreso', type: 'Date', required: true },
  { name: 'FechaContratoHasta', type: 'Date', required: false },
  { name: 'Telefono', type: 'Integer', required: true, maxlength: 10 },
  { name: 'Salario', type: 'Integer', required: true, min: 0, maxlength: 15 },
  { name: 'TipoContrato', type: 'Enum', required: true },
  {
    name: 'Embargo',
    type: 'Enum',
    required: true,
    options: [true, false],
  },
  {
    name: 'esInsolvente',
    type: 'Enum',
    required: true,
    options: [true, false],
  },
  {
    name: 'otrasDeduccionesSalario',
    folder: 'informacionEmpresa',
    type: 'Integer',
    required: true,
    min: 0,
  },
  {
    name: 'cantidadLlamadosAtencion',
    folder: 'informacionEmpresa',
    type: 'Integer',
    required: true,
    min: 0,
  },
  {
    name: 'evaluacionDesempeno',
    folder: 'informacionEmpresa',
    type: 'Integer',
    required: true,
    min: 0,
    max: 100,
  },
  {
    name: 'montoMaximoCuota',
    folder: 'informacionEmpresa',
    type: 'Integer',
    required: true,
    min: 0,
  },
  {
    name: 'diasVacacionesDisponibles',
    folder: 'informacionEmpresa',
    type: 'Integer',
    required: true,
    min: 0,
  },
  {
    name: 'tipoSalario',
    folder: 'nomina',
    type: 'String',
    required: false,
  },
  {
    name: 'frecuenciaPago',
    folder: 'nomina',
    type: 'Enum',
    required: true,
    options: ['Mensual', 'Quincenal'],
  },
  {
    name: 'tipoCuentaBancaria',
    folder: 'datosBancarios',
    type: 'Enum',
    required: true,
    options: ['Corriente', 'Ahorros', 'Fiducia', 'Vista'],
  },
  {
    name: 'entidadBancaria',
    folder: 'datosBancarios',
    type: 'String',
    required: true,
    maxlength: 255,
  },
  {
    name: 'numeroCuentaBancaria',
    folder: 'datosBancarios',
    type: 'String',
    required: true,
    maxlength: 34,
  },
  {
    name: 'codigoBancario',
    folder: 'datosBancarios',
    type: 'Enum',
    required: false,
    maxlength: 11,
    minlength: 2,
  },
];

export default esquemaEmpleado;
